<template>
  <div class="cs-el-scs-input-container">
    <div v-if="isEditing">
      <el-select v-if="isDropdown" class="input-width" :value="currentValue" size="mini" :placeholder="placeholder" @change="handleChange">
        <el-option v-for="item in dropdownListData" :key="item.Key" :label="item.Value" :value="item.Key"></el-option>
      </el-select>
      <el-input class="cs-el-scs-input" v-else :placeholder="placeholder" :maxlength="maxlength" size="mini" :value="currentValue"
        @input="handleInput">
        <template v-if="isPercentage" slot="append">%</template>
      </el-input>
      <i @click="onSave()"
        :class="{'el-icon-success': true, 'cs-custom-input-save': true, 'cs-custom-input-percentage-save':isPercentage}"></i>
    </div>
    <div v-else @click="onEdit">
      <div v-if="!currentValue && currentValue !== 0">
        <span>&nbsp;</span>
      </div>
      <div :class="className" v-else>
        <span>{{currentValue}}</span>
        <span v-if="isPercentage">%</span>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.cs-el-scs-input-container {
  position: relative;
  padding: 5px 40px 5px 0;

  .cs-el-scs-input {
    /deep/ .el-input-group__append {
      padding: 0 10px;
    }
  }

  .cs-custom-input-save {
    color: #35b02b;
    font-size: 18px;
    position: absolute;
    right: 42px;
    top: 14px;
    cursor: pointer;
  }
  .cs-custom-input-percentage-save {
    right: 76px;
  }
}
</style>

<script>
import { getStudyAbroadUniversityScoreColor } from "@/config/mUtils.js";
export default {
  props: {
    isReadonly: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number],
      required: false,
    },
    inputType: {
      type: Number,
      default: 0,
    },
    maxlength: {
      type: Number,
      default: 20,
    },
    isPercentage: Boolean,
    placeholder: String,
    isDropdown: Boolean,
    dropdownListData: Array,
    isInEditing: {
      type: Boolean,
      default: false,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isEditing: false,
      className: "",
      currentValue:
        this.value === undefined || this.value === null ? "" : this.value,
    };
  },
  computed: {},
  created() {
    if (this.isReadonly){
      this.isEditing = false;
    }else{
      this.isEditing = this.isInEditing;
    }
  },
  methods: {
    getRegexValue(value) {
      let min = this.min;
      let max = this.max;
      if (this.isPercentage && !this.max) {
        max = 100;
      }

      switch (this.inputType) {
        case this.GLOBAL.inputType.int: {
          value = value.replace(/[^0-9]/g, "");
          if (!!value) {
            let intValue = parseInt(value);
            if (!!min && intValue < this.min) {
              intValue = min;
            }
            if (!!max && intValue > max) {
              intValue = max;
            }
            value = intValue.toString();
          }
          break;
        }
        case this.GLOBAL.inputType.decimal: {
          value = value.replace(/[^0-9.]/g, "");
          if (!!value) {
            let floatValue = parseFloat(value);
            if (!!min && floatValue < min) {
              floatValue = min;
            }
            if (!!max && floatValue > max) {
              floatValue = max;
            }
            value = floatValue.toString();
          }
          break;
        }
      }
      return value;
    },
    setCurrentValue(value) {
      if (typeof value == undefined) {
        value = this.value;
      }

      this.currentValue = value;
      
      // if (this.inputType == this.GLOBAL.inputType.int){
      //   this.className = getStudyAbroadUniversityScoreColor(value);
      // }else 
      if (this.inputType == this.GLOBAL.inputType.decimal){
        let n = value;
        if (!!value) {
          n = parseFloat(value);
        }
        this.className = getStudyAbroadUniversityScoreColor(n * 20);
      } else{
        this.className = getStudyAbroadUniversityScoreColor(value);
      }
    },
    handleInput(newVal) {
      newVal = this.getRegexValue(newVal);
      this.setCurrentValue(newVal);
      this.$emit("input", newVal);
    },
    handleChange(newVal){
      this.setCurrentValue(newVal);
      this.$emit("input", newVal);
    },
    onEdit() {
      if (this.isReadonly){
        return;
      }
      this.isEditing = true;
    },
    onSave() {
      this.isEditing = false;
    },
  },
  watch: {
    value: function (newVal) {
      this.setCurrentValue(newVal);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/common/el-scs-input.vue